import Money from 'common/components/layout/Money';

const Price = (props) => {
  const { variant, settings } = props;
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice || variant.addToCartPrice >= variant.price) {
    return (
      <div className="c7-product__variant__price">
        <Money number={variant.addToCartPrice} settings={settings} />
      </div>
    );
  }

  return (
    <div className="c7-product__variant__price__sale">
      {variant.actionMessage}{' '}
      <Money number={variant.addToCartPrice} settings={settings} />
    </div>
  );
};

export default Price;
